import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueFire from 'vuefire'
import Vuex from 'vuex'
import Sortable from 'vue-sortable'
import { store } from './store/store.js';
import '@babel/polyfill'
import './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'font-awesome/css/font-awesome.min.css' // Ensure you are using css-loader
import '../node_modules/vuetify/src/stylus/app.styl'
import '../src/assets/styl/app.styl'
Vue.use(VueFire);
Vue.use(Vuex);
Vue.use(Sortable);
// main.js
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vuetify from 'vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(Vuetify, {
    iconfont: { icon: ['mdi','fa4']},
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBHzfdn4jHyA3idnR0C546_gDbTk40TvII',
    libraries: 'places,drawing,visualization'
  },
})
Vue.config.productionTip = false

new Vue({
  // el: '#app', 
  router,
  store,
  components: { App },
  render: h => h(App)
}).$mount('#app')
